import {Injectable} from '@angular/core';
import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: 'root'
})
export class DatepickerService {

  public parseDateToNgbDateStruct(date: Date): NgbDateStruct {
    date = new Date(date);
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    }
  }

  public parseNgbDateStructToDate(date: NgbDateStruct): Date {
    return new Date(
      date.year,
      date.month - 1,
      date.day
    );
  }

  public parseNgbDateStructToIsoFormat(date: NgbDateStruct, hour?: number, minutes?: number): string {
    const formattedMonth = date.month.toString().padStart(2, '0');
    const formattedDay = date.day.toString().padStart(2, '0');
    const parsedDate = `${date.year}-${formattedMonth}-${formattedDay}`;

    if (hour != null && minutes != null) {
      const formattedHour = hour.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');
      return `${parsedDate}T${formattedHour}:${formattedMinutes}:00`;
    }

    return parsedDate;
  }
}
